import { TWorkRequest } from '@commenda/types/src/work-request/types';
import { SWRFetcher } from '@commenda/utils';
import { WorkRequestType } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

const useGetWorkRequestsByCompany = (
  companyId: number,
  includeFiles = false,
  requestType: WorkRequestType[] = []
) => {
  const queryParams = new URLSearchParams();

  if (includeFiles) queryParams.append('includeFiles', 'true');
  if (requestType.length > 0)
    requestType.forEach((t) => queryParams.append('types', t));

  const {
    data,
    error,
    mutate,
  }: {
    data?: { workRequests: TWorkRequest[] };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId
      ? `workRequest/byCompanyId/${companyId}?${queryParams.toString()}`
      : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
};

export default useGetWorkRequestsByCompany;
